import React from 'react';
import { getLang } from 'lowcomp/plugins/member/utils';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';

import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { useLuckyStore } from '../LuckyProvider';

interface FlopGameProps {
    flopList: any[];
    status: 1 | 2 | 3;
    disabledGame: boolean;
    handleChoose: (num: number) => void;
    bgImage: string;
    frontImage: string;
    backImage: string;
    kvImage: string;
    handleStart: () => void;
    handleAccept: () => void;
}

const defaultImage = 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1730796539339/20241104-174634.jpeg';

const FlopGame: React.FC<FlopGameProps> = ({
    status,
    flopList,
    disabledGame,
    handleChoose,
    bgImage,
    frontImage,
    backImage,
    kvImage,
    handleStart,
    handleAccept,
}) => {
    const { locale, pathname } = getLocal();
    const t = getLang(textLang, locale);
    const { LUCKY_ACTIVE: luckyActivety } = useLuckyStore();

    return (
        <div className={css.flop}>
            {status === 1 ? (
                <div className="flop_bg">
                    {!bgImage && <EditorImg pc={kvImage || defaultImage} />}
                    {/* <NextImage src={require(`@publicLocal/ecocredits/${isMobile ? 'h5' : 'pc'}/lucky-flopbg.jpg`)} alt="" /> */}
                </div>
            ) : (
                <div className="flop_content">
                    <div className="flop_box">
                        {flopList &&
                            flopList.map((item, index) => (
                                <div
                                    className={`flop_item ${item.checked ? '' : 'disabled'}`}
                                    key={item.id}
                                    onClick={() => handleChoose(index)}
                                    style={{ transform: `translate(${item.x}px, ${item.y}px) ${item.flip ? 'rotateY(180deg)' : ''}` }}
                                >
                                    <div className="flop_front">
                                        <EditorImg pc={backImage} />
                                    </div>
                                    <div className="flop_black">
                                        <EditorImg pc={frontImage} />
                                        <div className="flop_prize">
                                            {/* {item.checked && item.type !== 'NOTHING' && <p className="congratulate">{t('lucky_flop_congrat')}</p>} */}
                                            {item.imgUrl && (
                                                <div className="flop_prize_img">
                                                    <EditorImg className="" pc={item.imgUrl} alt={item.title} />
                                                </div>
                                            )}
                                            <h6 className="prize_title">{item.title}</h6>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            )}
            <div className={`flop_tools ${status === 2 ? 'hide' : ''}`}>
                {luckyActivety?.limitFlag && (
                    <p className="flop_times">
                        {t.rich('remaining_number2', {
                            code: () => <i className="flop_times_counts">{luckyActivety?.available || 0}</i>,
                        })}
                    </p>
                )}
                {status === 1 && (
                    <EditorLink
                        className={`flop_btn ${disabledGame ? 'disabled' : ''}`}
                        onClick={handleStart}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_button',
                            page_name: pathname,
                            list_name: 'Flip Cards',
                            button_name: t('lucky_flop_start'),
                            function: 'Flip Cards',
                        }}
                    >
                        {t('lucky_flop_start')}
                    </EditorLink>
                )}
                {status === 3 && (
                    <EditorLink className="flop_btn" onClick={handleAccept}>
                        {t('lucky_flop_get')}
                    </EditorLink>
                )}
            </div>
        </div>
    );
};
export default FlopGame;
